/**
 * Possible Panel Types on Regression Pages
 */
export const PANELS = {
  ERROR: 'Error',
  FAILED: 'Failed',
  PASSED: 'Passed',
  PENDING: 'Pending',
  RUNNING: 'Running',
  SKIPPED: 'Skipped',
  TRENDING: 'Trending',
  UNKNOWN: 'Unknown'
};

export const FAILURE_TRENDS = 'failureTrends';
export const DISPATCHER_INFO = 'dispatcherInfo';


// WEBPACK FOOTER //
// src/helpers/commonPageInfo.js